<template>
    <div class="w-full mx-auto relative flex flex-col" style="max-width: 1400px;">
        <div class="p-3">
            <Gallery :images="imagesForHeader" :keep-aspect-ratio="true" passClasses="max-h-[500px]" />
        </div>
        <div class="flex flex-col lg:flex-row pt-12 md:pt-24">
            <div class="px-12 lg:px-24 text-left flex flex-col w-full lg:w-[60%] gap-16 md:gap-24">
                <div>
                    <h1 class="font-written text-4xl">Petri Kirche</h1>
                    <p class="text-lg text-gray-500 mt-3">Guthmannshausen</p>
                    <div
                        class="flex flex-col items-start gap-3 mt-5 max-w-[550px] rounded-md overflow-hidden bg-white shadow-md">
                        <img src="/assets/kirchen/guthmannshausen/senioren.webp" class="w-full">
                        <p class="text-sm p-3"><span class="text-base font-bold">Sommerfest der Senioren
                                2016</span><br><br>In diese Kirche kommt man nicht nur zum sonntäglichen Gottesdienst,
                            auch werden hier unterschiedlichste Veranstaltungen abgehalten.</p>
                    </div>
                </div>
            </div>
            <div class="text-left sticky mt-16 lg:mt-0 flex-auto px-3 lg:px-0 pr-3 lg:pr-12 lg:pr-24 top-[115px] h-min">
                <div class="flex-auto lg:w-auto flex flex-col items-center">
                    <div class="flex flex-col w-full gap-3">
                        <!-- <p class="text-md text-gray-500 px-1">Kontakt</p>
                        <div class="flex flex-col w-full p-6 rounded-md bg-white"
                            style="box-shadow: 5px 5px 15px rgba(0, 0, 0, 0.15);">
                            <div>
                                <p class="font-bold">Hans-Ulrich Bayer (Pfarrer)</p>
                                <div class="flex flex-col gap-1 mt-3">
                                    <p class="flex"><span class="w-14 font-bold mr-8">Mobil</span> <a
                                            href="tel:017670817415" class="hover:underline">0176 / 70817415</a></p>
                                    <p class="flex"><span class="w-14 font-bold mr-8">E-Mail</span> <a
                                            href="mailto:hans-ulrich.bayer@ekmd.de"
                                            class="hover:underline">hans-ulrich.bayer@ekmd.de</a>
                                    </p>
                                </div>
                            </div>

                            <div class="mt-8">
                                <p class="font-bold">Pfarreramt Rastenberg</p>
                                <div class="flex flex-col gap-1 mt-3">
                                    <p class="flex"><span class="w-14 font-bold mr-8">Adresse</span> Lossaer Str. 8,
                                        <br>99636
                                        Rastenberg
                                    </p>
                                    <p class="flex"><span class="w-14 font-bold mr-8">Telefon</span> <a
                                            href="tel:03637780324" class="hover:underline">036377 / 80324</a></p>
                                </div>
                            </div>

                            <div class="mt-8">
                                <p class="font-bold">Öffnungszeiten</p>
                                <div class="flex flex-col gap-1 mt-3">
                                    <p class="flex"><span class="w-14 font-bold mr-8">Dienstag</span> 9.00 - 15.00 Uhr
                                    </p>
                                </div>
                            </div>
                        </div> -->
                        <div v-if="data.length > 0">
                            <p class="text-md text-gray-500 px-1 mt-3 mb-3">Nächster Gottesdienst</p>
                            <div class="flex flex-col gap-3">
                                <template v-for="(i, n) in data.slice(0, 2)" :key="n">
                                    <div class="bg-white rounded-md flex flex-col gap-3 text-left overflow-hidden select-none"
                                        style="box-shadow: 5px 5px 15px rgba(0, 0, 0, 0.15);">
                                        <div class="flex items-center justify-between px-3 py-2 bg-gray-500">
                                            <p class="text-sm text-white">{{ i.date }}</p>
                                            <p class="text-sm text-white">{{ i.time }}</p>
                                        </div>
                                        <div class="flex gap-10 p-3">
                                            <div>
                                                <p class="font-bold">{{ i.title }}</p>
                                                <p class="text-sm text-gray-500">Thema des Gottesdienstes</p>
                                            </div>
                                            <div class="ml-auto text-right" :title="i.location">
                                                <p>{{ i?.location.split(',').reverse()[0].replace(/\d+/g, "") }}</p>
                                                <p class="text-sm text-gray-500">Ort</p>
                                            </div>
                                        </div>
                                    </div>
                                </template>
                            </div>

                            <p class="mt-4 italic text-right text-xs text-gray-500">Daten von <a
                                    href="https://kg-rastenberg.ekmd-online.de/gottesdienste/"
                                    class="hover:underline hover:text-primary-default font-bold">kg-rastenberg.ekmd-online.de</a>
                                bereitgestellt.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="w-11/12 mx-auto h-0.5 rounded-md bg-gray-300 mt-16 lg:mt-28"></div>
        <div class="flex flex-col p-12 lg:p-24 text-left">
            <h2 class="font-written text-4xl">Restaurierung der Heerwagen-Orgel</h2>
            <p class="text-lg text-gray-500 mt-3">Aktuelles Projekt</p>
            <div class="mt-5 flex flex-wrap gap-2">
                <div class="w-72 rounded-md shadow-md overflow-hidden bg-white">
                    <img src="/assets/kirchen/guthmannshausen/orgel-1.webp" class="w-full aspect-[4/3] object-cover">
                </div>
                <div class="w-72 rounded-md shadow-md overflow-hidden bg-white">
                    <img src="/assets/kirchen/guthmannshausen/orgel-2.webp" class="w-full aspect-[4/3] object-cover">
                </div>
                <div class="w-72 rounded-md shadow-md overflow-hidden bg-white">
                    <img src="/assets/kirchen/guthmannshausen/orgel-3.webp" class="w-full aspect-[4/3] object-cover">
                </div>
                <div class="w-72 rounded-md shadow-md overflow-hidden bg-white">
                    <img src="/assets/kirchen/guthmannshausen/orgel-4.webp" class="w-full aspect-[4/3] object-cover">
                </div>
                <div class="w-72 rounded-md shadow-md overflow-hidden bg-white">
                    <img src="/assets/kirchen/guthmannshausen/orgel-5.webp" class="w-full aspect-[4/3] object-cover">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Gallery from '@/components/gallery.vue';

export default {
    name: "Guthmannshausen",
    data() {
        return {
            data: [],
            imagesForHeader: [
                {
                    url: "/assets/kirchen/guthmannshausen/guthmannshausen-1.webp",
                    alt: "Guthmannshausen 1"
                },
                {
                    url: "/assets/kirchen/guthmannshausen/guthmannshausen-2.webp",
                    alt: "Guthmannshausen 2"
                },
                {
                    url: "/assets/kirchen/guthmannshausen/guthmannshausen-3.webp",
                    alt: "Guthmannshausen 3"
                },
                {
                    url: "/assets/kirchen/guthmannshausen/guthmannshausen-4.webp",
                    alt: "Guthmannshausen 4"
                }
            ]
        }
    },
    components: {
        Gallery
    },
    async created() {
        this.data = (await this.$userStore.getData()).filter(f => f.location.includes("Guthmannshausen"));
    }
}
</script>